import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { LinkedProfile } from './types';

interface UnlinkConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  profile: LinkedProfile | null;
}

const UnlinkConfirmationModal = ({ open, onClose, onConfirm, profile }: UnlinkConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {t('screening.profile_management.remove_profile_confirm_title')}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('screening.profile_management.remove_profile_confirm_description')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('screening.profile_management.cancel')}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="secondary"
          variant="contained"
          sx={{
            color: "#fff",
            backgroundColor: 'secondary.main',
            '&:hover': {
              backgroundColor: 'secondary.main',
            }
          }}
        >
          {t('screening.profile_management.remove_profile_confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnlinkConfirmationModal; 